export default __webpack_public_path__ + "static/media/InterestedIcon.9fe4fb39.svg";